(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('PartySearchService', PartySearchService);

    PartySearchService.$inject = ['$uibModal'];

    function PartySearchService ($uibModal) {
        var service = {
            open: open,
            
            
        };

        var modalInstance = null;
        var callback = null;
        var cancelCallback = null;

        var resultModal = function (result) {
            if(callback != null)
            {
                callback(result);
            }

            callback = null;
            cancelCallback = null;
            modalInstance = null;
        };

        var resetModal = function (result) {
            if(cancelCallback != null)
            {
                cancelCallback();
            }
            callback = null;
            cancelCallback = null;
            modalInstance = null;
        };

        return service;

        function open (callbackFn, cancelFn) {
            callback = callbackFn;
            cancelCallback = cancelFn;
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/party/party-search.html',
                controller: 'PartySearchController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }],
                    party: ['$stateParams', 'AppPartySvc', function($stateParams, AppPartySvc) {
                        return AppPartySvc.get().$promise;
                    }]
                }
            });
            modalInstance.result.then(
                resultModal,
                resetModal
            );
        }
        
    
     
    }
})();
